import { Component, HostBinding, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    AuthenticatorService,
    UserType,
} from '../../Services/authenticator.service';
import { NgxUiLoaderService, SPINNER } from 'ngx-ui-loader';
import { Title } from '@angular/platform-browser';
import { OverlayContainer } from '@angular/cdk/overlay';
import { environment } from 'src/environments/environment';
import { EncryptorService } from '../../Services/encryptor.service';
import { MatDialog } from '@angular/material/dialog';
import { EvaluacionDocentePDFService } from '../../Modules/ResultadosEvaluacionDocente/Services/evaluacion-docente-pdf.service';
import { PdfViewerDialogComponent } from '../../Modules/Main/Components/pdf-viewer-dialog/pdf-viewer-dialog.component';
@Component({
    selector: 'app-loading-validate-code',
    templateUrl: './loading-validate-code.component.html',
    styleUrls: ['./loading-validate-code.component.css'],
    standalone: false
})
export class LoadingValidateCodeComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private auth: AuthenticatorService,
        private ngxService: NgxUiLoaderService,
        private title: Title,
        private overlay: OverlayContainer,
        private encryptorService: EncryptorService,
        private matDialog: MatDialog,
        private evaluacionDocentePDFService: EvaluacionDocentePDFService
    ) {}

    _fgsSize: number = 100;
    SPINNER = SPINNER;

    themeKey = 'THEME';
    colorThemeKey = 'THEME-COLOR';

    @HostBinding('class') className = '';

    darkMode: boolean = true;
    defaultColor: boolean = true;

    pageTitle: string = 'SCEU :: QR Code';
    production: boolean = environment.production;
    check: boolean = environment.check;

    data: any;

    ngOnInit() {
        this.setTitle();
        this.checkTheme();
        this.fgsSize();
        this.ngxService.startLoader('loader');
        window.addEventListener('resize', () => {
            this.ngxService.stopLoader('loader');
            this.fgsSize();
            this.ngxService.startLoader('loader');
        });

        this.route.queryParams.subscribe((params) => {
            if (params.code) {
                const code: string = this.encryptorService.aesDecrypt(
                    params.code,
                    true
                );
                const data: any = JSON.parse(code);

                if (data?.action == 'Evaluación Docente') {
                    this.pageTitle = 'SCEU :: ' + data.action;
                    this.setTitle();
                    if (this.auth.expectedRole(UserType.DesarrolloAcademico)) {
                        this.evaluacion(data.no_de_control, data.periodo);
                    } else {
                        this.router.navigate(['/']);
                    }
                } else {
                    this.router.navigate(['/']);
                }
            } else {
                this.router.navigate(['/']);
            }
        });
    }

    fgsSize() {
        const height: number = window.screen.height;
        if (height < 300) {
            this._fgsSize = 60;
        } else if (height < 400) {
            this._fgsSize = 70;
        } else if (height < 500) {
            this._fgsSize = 80;
        } else if (height < 600) {
            this._fgsSize = 90;
        } else {
            this._fgsSize = 100;
        }
    }

    setTheme(darkMode: boolean) {
        const darkClassName = 'darkMode';
        const darkDevClassName = 'darkMode-dev';
        const lightClassName = 'lightMode';
        const lightblueClassName = 'lightMode-default';
        const lightRedClassName = 'lightMode-red';
        const lightGreenClassName = 'lightMode-check';

        this.className = this.production
            ? darkMode
                ? darkClassName
                : lightClassName
            : this.check
            ? lightGreenClassName
            : darkDevClassName;

        localStorage.setItem(
            this.themeKey,
            this.encryptorService.aesEncrypt(this.className)
        );

        this.overlay
            .getContainerElement()
            .classList.remove(
                darkClassName,
                lightblueClassName,
                lightRedClassName,
                darkDevClassName
            );

        if (!this.production) {
            this.overlay.getContainerElement().classList.add(darkDevClassName);
        } else if (darkMode) {
            this.overlay.getContainerElement().classList.add(darkClassName);
        } else {
            this.checkColorLightTheme();
        }
    }

    setColorLightTheme(defaultColor: boolean) {
        const lightClassName = 'lightMode';
        const lightblueClassName = 'lightMode-default';
        const lightRedClassName = 'lightMode-red';

        const redClassName = 'red';
        const blueClassName = 'blue';

        this.className = defaultColor ? lightblueClassName : lightRedClassName;

        const className = defaultColor ? blueClassName : redClassName;

        localStorage.setItem(
            this.colorThemeKey,
            this.encryptorService.aesEncrypt(className)
        );

        this.overlay
            .getContainerElement()
            .classList.remove(lightblueClassName, lightRedClassName);

        if (defaultColor) {
            this.overlay
                .getContainerElement()
                .classList.add(lightblueClassName);
        } else {
            this.overlay.getContainerElement().classList.add(lightRedClassName);
        }
    }

    checkTheme() {
        const classStoraged = localStorage.getItem(this.themeKey);
        const className = classStoraged
            ? this.encryptorService.aesDecrypt(classStoraged)
            : '';
        const darkMode = className == 'darkMode';

        this.setTheme(darkMode);

        this.darkMode = darkMode;
    }

    setTitle() {
        this.title.setTitle(this.pageTitle);
    }

    checkColorLightTheme() {
        const redClassName = 'red';

        const classStoraged = localStorage.getItem(this.colorThemeKey);
        const className = classStoraged
            ? this.encryptorService.aesDecrypt(classStoraged)
            : '';
        const defaultColor = className != redClassName;

        this.setColorLightTheme(defaultColor);

        this.defaultColor = defaultColor;
    }

    async evaluacion(no_de_control: string, periodo: string) {
        this.ngxService.start();
        const pdf = await this.evaluacionDocentePDFService.generarPDF(
            periodo,
            no_de_control
        );
        this.ngxService.stop();
        if (pdf) {
            const dialogRef = this.matDialog.open(PdfViewerDialogComponent, {
                height: '100vh',
                width: '100vw',
                maxHeight: '100vh',
                maxWidth: '100vw',
                data: pdf,
            });

            dialogRef.afterClosed().subscribe(() => {
                this.router.navigate(['/']);
            });
        }
    }
}
